import { ListPartnerMaterialsAdminResponseSchema } from './list-partner-materials-admin.schema';
export const listPartnerMaterialsAdminContract = {
    method: 'GET',
    path: '/api/v2/admin/partner-materials',
    description: 'List all partner materials, inactive ones included',
    responseSchema: ListPartnerMaterialsAdminResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only'
        }
    }
};

//# sourceMappingURL=list-partner-materials-admin.contract.js.map